export enum collegeType{
    college = 1,
    universityAdministration = 2
}
